const cta = {
  props: {
    dynamicClass: ".c-cta.dynamicLoading",
    cssBtnSelector: "c-cta",
    obfuscatedUrlSelector: "js-obfuscated-url",
    jsSelector: ".functional-JS",
    jsSelectorCTA: "JS-launcher-CTA",
    currentPageWildcard: "currentPageWildcard",
    countryWildcard: "countryWildcard",
    mybBookingClass: ".myb-bookings-JS",
    modDisabledClass: "mod--disabled",
    pointerNoneClass: "pointer-none",
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-cta.css", this.props.dynamicClass);

    const ctas = document.querySelectorAll(this.props.jsSelector);
    bcl.u.forEach(ctas, function (cta) {
      const functionToExecute = cta.getAttribute("data-call-action");
      const typeEvent = cta.getAttribute("data-type-event");
      let parameters = cta.getAttribute("data-parameters");
      if (!cta.getAttribute("loaded")) {
        cta.setAttribute("loaded", true);
        cta.addEventListener(typeEvent, function () {
          if (functionToExecute) {
            if (parameters) {
              parameters = parameters.split(",");
            }
            bcl.u.executeFunctionByName(functionToExecute, window, parameters);
          }
        });
      }
    });

    const links = document.querySelectorAll(`.${this.props.cssBtnSelector}, .${this.props.obfuscatedUrlSelector}`);
    bcl.u.forEach(links, (link) => {
      if (!link) {
        return;
      }

      const parentLink = link.parentElement?.classList?.contains(cta.props.jsSelectorCTA) ? link.parentElement : null;
      const nestedLink = link.querySelector(`.${cta.props.jsSelectorCTA}`);

      if (link?.dataset?.encodedHref) {
        link.href = atob(link.dataset.encodedHref);
        delete link.dataset.encodedHref;
      }

      if (!link.href) {
        link = parentLink || nestedLink || link;
      }

      if (link.href) {
        const updateHref = (wildcard, replacement) => {
          link.href = link.href.replaceAll(wildcard, replacement);
        };

        if (link.href.includes(cta.props.currentPageWildcard)) {
          const currentPage = `${window.location.pathname}${window.location.search}`;
          const concatSymbol = window.location.search ? "&" : "?";
          const wildcardWithQuery = `${cta.props.currentPageWildcard}?`;
          const wildcardWithAmpersand = `${cta.props.currentPageWildcard}&`;

          if (link.href.includes(wildcardWithQuery)) {
            updateHref(wildcardWithQuery, currentPage + concatSymbol);
          } else if (link.href.includes(wildcardWithAmpersand)) {
            updateHref(wildcardWithAmpersand, encodeURIComponent(currentPage) + concatSymbol);
          } else {
            updateHref(cta.props.currentPageWildcard, currentPage);
          }
        }

        if (link.href.includes(cta.props.countryWildcard)) {
          updateHref(cta.props.countryWildcard, bcl.u.getCountryCode());
        }

        link.classList.remove(cta.props.modDisabledClass, cta.props.pointerNoneClass);
      }
    });

    const launchersCTA = document.querySelectorAll("." + bcl.c.cta.props.jsSelectorCTA);
    launchersCTA.forEach((launcher) => {
      if (launcher.dataset.paramurldialog) {
        let url;
        if (launcher.href.includes(".html")) {
          url = launcher.href.split(".html")[0];
          launcher.href = url + "--" + launcher.dataset.paramurldialog + ".html";
        } else {
          url = launcher.href.slice(0, -1);
          launcher.href = url + "--" + launcher.dataset.paramurldialog;
        }
      }
    });
  },
  openMybBookings: function () {
    event.preventDefault();
    const formDetail = document.querySelector(bcl.c.cta.props.mybBookingClass);
    formDetail.submit();
  },
};

export default cta;
